module.exports = __webpack_public_path__ + "assets/img/b5e1b830602836908dd637f51c4c71f5.png";